import React from 'react'

export default function ProgressNavSmall({ steps = 1, step = 1, className = '', labels = [] }) {
    const arr = new Array(steps).fill(0)
    let classes = 'progressNavSmall'
    if (className) classes += ' ' + className

    if (labels.length === steps) {
        return (
            <ol className={`${classes} progressNavSmall--labelled`}>
                {arr.map((_, index) => {
                    const itemStep = index + 1
                    let itemClasses = 'progressNavSmall-item'
                    if (itemStep === step) itemClasses += ' progressNavSmall-item-selected'
                    if (itemStep < step) itemClasses += ' progressNavSmall-item-completed'
                    return (
                        <li
                            key={labels[index]}
                            className={itemClasses}
                            aria-current={itemStep === step ? 'step' : undefined}
                        >
                            <span className='progressNavSmall-item-number'>{itemStep}</span>
                            <span className='progressNavSmall-item-label'>{labels[index]}</span>
                        </li>
                    )
                })}
            </ol>
        )
    }

    return (
        <div className={classes}>
            {arr.map((_, index) => {
                let stepClasses = 'progressNavSmall-step'
                if (step === index + 1) stepClasses += ' progressNavSmall-step-selected'
                return <div key={index} className={stepClasses} />
            })}
        </div>
    )
}
